<template>
  <el-card header="员工信息" class="box-card">
    <el-form :model="formData" :rules="rules" ref="dataForm" label-width="100px">
      <el-form-item label="名称" prop="name">
        <el-input v-model="formData.name" />
      </el-form-item>
      <el-form-item label="手机/账号" prop="phone">
        <el-input v-model="formData.phone" />
      </el-form-item>
      <el-form-item label="密码" prop="password">
        <el-input v-model="formData.password" />
      </el-form-item>
      <el-form-item label=" ">
        <el-button type="primary" @click="submitForm">提交</el-button>
        <el-button @click="cancel">取消</el-button>
      </el-form-item>
    </el-form>
  </el-card>
</template>
<script>
export default {
  data() {
    return {
      formData: {
        id: null,
        name: "",
        phone: "",
        password: ""
      },
      typeList: [],
      rules: {
        name: [{ required: true, message: "请填写名称", trigger: "blur" }],
        phone: [{ required: true, message: "请填写手机", trigger: "blur" }],
        password: [{ required: true, message: "请填写密码", trigger: "blur" }]
      }
    };
  },
  created: function() {
    this.formData.id = this.$route.query.id;
    if (this.formData.id) {
      this.fetchData();
    }
  },
  methods: {
    fetchData() {
      var that = this;
      that.api.shop.staff.get({ id: that.formData.id }).then(response => {
        if (!response.data.errorCode) {
          Object.assign(that.formData, response.data.data);
        }
      });
    },
    submitForm() {
      var that = this;
      that.$refs["dataForm"].validate(valid => {
        if (valid) {
          that.api.shop.staff
            .save(Object.assign({}, that.formData))
            .then(function(response) {
              if (!response.data.errorCode) {
                that.$router.go(-1);
              }
            });
        } else {
          return false;
        }
      });
    },
    resetForm() {
      this.$refs["dataForm"].resetFields();
    },
    cancel() {
      this.$router.go(-1);
    }
  }
};
</script>


// WEBPACK FOOTER //
// Edit.vue?49077fee